import React from 'react';
import Typography from './Typography';
import clsx from 'clsx';

interface HeaderProps {
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
    alignment?: 'start' | 'center' | 'end';
    loading?: boolean;
    className?: string;
}

const Header: React.FC<HeaderProps> = ({
                                           title,
                                           subtitle,
                                           children,
                                           alignment = 'start',
                                           loading = false,
                                           className
                                       }) => {

    // Convert alignment to Tailwind classes
    const alignmentMap = {
        start: 'justify-start items-start text-left',
        center: 'justify-center items-center text-center',
        end: 'justify-end items-end text-right',
    };

    const contentAlignment = alignmentMap[alignment];
    const hasChildren = Boolean(children);

    return (
        <header
            className={clsx(
                'flex mb-6 mt-1 ml-8 mr-8',
                hasChildren ? 'justify-between items-center' : contentAlignment,
                className
            )}
        >
            <div className={clsx(!hasChildren && contentAlignment.split(' ')[2])}>
                <Typography
                    variant="h5"
                    component="h1"
                    gutterBottom={Boolean(subtitle)}
                    loading={loading}
                    skeletonWidth={loading ? 300 : undefined}
                >
                    {title}
                </Typography>

                {subtitle && (
                    <Typography
                        color="textSecondary"
                        component="div"
                        loading={loading}
                        skeletonWidth={loading ? 400 : undefined}
                    >
                        {subtitle}
                    </Typography>
                )}
            </div>

            {(children || loading) && (
                <div className="flex justify-start gap-1">
                    {loading ? (
                        <>
                            <div className="skeleton-loader h-10 w-24 rounded" />
                        </>
                    ) : (
                        children
                    )}
                </div>
            )}
        </header>
    );
};

export default Header;